export default "__VITE_PUBLIC_ASSET__6a06f411__"